import i18next from 'i18next'
import detector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import defaultEnglish from './default/en.json'
import defaultFr from './default/fr.json'
import defaultPtBR from './default/pt-br.json'

import en from './en/translation.json'
import fr from './fr/translation.json'
import ptBR from './pt-br/translation.json'

const translationEnglish = { ...defaultEnglish, ...en }
const translationPortuguese = { ...defaultPtBR, ...ptBR }
const translationFrench = { ...defaultFr, ...fr }

// Using translation
const resources = {
  en: {
    translation: translationEnglish,
  },
  pt: {
    translation: translationPortuguese,
  },
  'pt-BR': {
    translation: translationPortuguese,
  },
  fr: {
    translation: translationFrench,
  },
}

i18next
  .use(initReactI18next)
  .use(detector)
  .init({
    resources,
    lng: 'pt-BR', // default language
    fallbackLng: ['pt-BR', 'pt', 'en', 'fr'],
    whitelist: ['pt-BR', 'pt', 'en', 'fr'],
    detection: {
      lookupLocalStorage: '@vallourec-language',
    },
  })

export default i18next
